import { render, staticRenderFns } from "./StagTable.vue?vue&type=template&id=27da1320&scoped=true"
import script from "./StagTable.vue?vue&type=script&lang=js"
export * from "./StagTable.vue?vue&type=script&lang=js"
import style0 from "./StagTable.vue?vue&type=style&index=0&id=27da1320&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27da1320",
  null
  
)

export default component.exports